import React, { useEffect, useState } from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


// custom compoennts
import { MessengerProfilePicture } from '_molecules';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectReceipientsInformation, setSelectedConversation, getMessages, selectSelectedConversation, selectConversations, getUserInfo, selectFetchNameStatus } from '_redux/slices/messaging/messaging'

// firebase messaging
import { collection, onSnapshot } from "firebase/firestore";
import { firestore } from '_utils/firebase-app';

// styling
import { Colors, Spacing } from '_styles';

const PassengerMessage = (props) => {

    // redux
    const dispatch = useDispatch();

    const conversations = useSelector(selectConversations);                     // list of chats, research for names if required
    const selectedConversation = useSelector(selectSelectedConversation);
    const fetchStatus = useSelector(selectFetchNameStatus)
    const userList = useSelector(selectReceipientsInformation)

    const userId = props.conversation?.id?.split('-')[0];
    const displayName = userList?.[userId]?.displayName;
    const styledName = displayName?.length > 18 ? displayName.substring(0, 18) + '...' : displayName || '';


    const [cachedSearch, setCachedSearch] = useState('');              // cache used to stop infinte repeat fetch
    const [lastActivity, setLastActivity] = useState('');
    const [formattedDate, setFormattedDate] = useState('');
    const [showNotification, setShowNotification] = useState('');             // show notificaiton badge

    // user id listener
    useEffect(() => {
        if (props.conversation && props.conversation.id && props.conversation.id.split('-')[0]) {
            let conversationId = props.conversation.id
            let userId = props.conversation.id.split('-')[0]

            if (userList != undefined && userList[userId] != undefined && userList[userId] && userList[userId].displayName) {
                // already retrieved name
                //dispatch(getUserInfo(userId))
            }
            else if (cachedSearch != userId) {
                // need to retrieve name
                dispatch(getUserInfo(userId))
                setCachedSearch(userId)
            }
        }
    }, [conversations]);

    useEffect(() => {
        if (props.conversation && props.conversation.lastAction && props.conversation.lastAction !== undefined) {
            const lastAction = props.conversation.lastAction;
            const jsDate = new Date(lastAction.seconds * 1000); // Multiply by 1000 to convert from seconds to milliseconds
            const currentDate = new Date();

            // Calculate the difference in days between the two dates
            const dayDifference = Math.floor((currentDate - jsDate) / (24 * 60 * 60 * 1000));

            if (dayDifference === 0) {
                // If it's today, format the time
                const hours = jsDate.getHours().toString().padStart(2, '0');
                const minutes = jsDate.getMinutes().toString().padStart(2, '0');
                const formattedTime = `${hours}:${minutes}`;
                setLastActivity(formattedTime);
            } else if (dayDifference < 7) {
                // If it's within the current week, display the day of the week
                const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                const dayOfWeek = daysOfWeek[jsDate.getDay()];
                setLastActivity(dayOfWeek);
            }

            // get date dd/mm/yyyy
            const day = jsDate.getDate();
            const month = jsDate.getMonth() + 1; // Months are 0-based, so add 1
            const year = jsDate.getFullYear();
            const formattedDate = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
            setFormattedDate(formattedDate);

        }
    }, [props]);

    useEffect(() => {
        if (props.conversation && props.conversation.id) {
            let isFirstSnapshot = true;
            const unsubscribe = onSnapshot(
                collection(firestore, `conversations/${props.conversation.id}/messages`),
                (snapshot) => {
                    snapshot.docChanges().forEach((change) => {
                        if (change.type === 'added') {

                            const newMessage = change.doc.data();

                            if (!isFirstSnapshot) {
                                setShowNotification(true);
                            }
                        }
                    });

                    if (isFirstSnapshot) {
                        isFirstSnapshot = false; // Update the flag after the first snapshot
                    }
                }
            );

            return () => unsubscribe();
        }
    }, [props.conversation]);

    useEffect(() => {
        if (props.conversation.notification) { setShowNotification(true) }
    }, [props.conversation]);

    // set selected conversation and get chats
    const onClick = () => {
        dispatch(setSelectedConversation(props.conversation))
        dispatch(getMessages({ conversation: props.conversation.id }))
        setShowNotification(false)
    }

    return (
        <Row>

            <div
                onClick={() => { onClick(props.conversation) }}
                style={{
                    cursor: 'pointer', borderRadius: 10,
                    backgroundColor: props.conversation && props.conversation.id && selectedConversation && selectedConversation.id && props.conversation.id == selectedConversation.id ? Colors.GRAY_LIGHT : 'white',
                    display: 'flex', marginTop: Spacing.SCALE_4, marginBottom: Spacing.SCALE_4
                }}
            >

                {/* Profile Picture */}
                <Col xs={3}>
                    <div>
                        <MessengerProfilePicture user={props.conversation.id && props.conversation.id.split('-')[0] ? props.conversation.id.split('-')[0] : null} />
                    </div>
                </Col>

                {/* Passenger Name & Last Message Date */}
                <Col>

                    <Row>
                        <div>
                            {
                                fetchStatus == 'loading' ?
                                    <p></p>
                                    :
                                    <div className='mt-2' style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                        {/* Passenger Name */}
                                        <p
                                            style={{
                                                fontSize: 18,
                                                fontWeight: '400',
                                                textAlign: 'left',
                                                color: 'black',

                                            }}>
                                            {styledName}
                                        </p>
                                        {/* Notification Badge */}
                                        {showNotification &&
                                            <div
                                                className='mt-1'
                                                style={{ height: 15, width: 15, backgroundColor: Colors.PRM_LIGHT_BLUE, borderRadius: 25 }}
                                            />}
                                    </div>
                            }
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <p style={{ opacity: 0.4, marginTop: -Spacing.SCALE_12, fontSize: 14 }}>{lastActivity}</p>
                            <p style={{ opacity: 0.4, marginTop: -Spacing.SCALE_12, fontSize: 14 }}>{formattedDate}</p>
                        </div>
                    </Row>

                </Col>

            </div>
        </Row>
    );
};

export default PassengerMessage;
